import script from "./LeadCaptureReport.vue?vue&type=script&setup=true&lang=js"
export * from "./LeadCaptureReport.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import LeadsReport from "@/components/reports/LeadsReport.vue";
import SignupSourceCard from "@/components/reports/SignupSourceCard.vue";
script.components = Object.assign({}, { LeadsReport, SignupSourceCard }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { LeadsReport, SignupSourceCard }, script.__o.components);}